
import { Options, Vue, prop } from "vue-class-component";
import isDisableSttManual from "@/app/infrastructures/misc/common-library/IsDisableSttManual";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import router from "@/app/ui/router";
import { debounce } from "lodash";
import { BulkBookingController } from "@/app/ui/controllers/BulkBookingController";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";
import { RequestValidateShipmentId } from "@/data/payload/api/ShipmentBookingRequest";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";

class Props {
  modelValue = prop<any>({
    required: true
  });
  error = prop<any>({
    required: true
  });
  formType = prop<string>({
    default: "",
    type: String
  });
  isFirstInput = prop<boolean>({
    default: false,
    type: Boolean
  });
  isClientDO = prop<boolean>({
    default: false,
    type: Boolean
  });
  errorMandatory = prop<any>({
    default: false,
    type: Boolean
  });
  isDO = prop<boolean>({
    default: false,
    type: Boolean
  });
  errorRepair = prop<any>({
    required: true,
  });
}

@Options({
  emits:["setFieldIndex"],
})
export default class SectionSTTManualReference extends Vue.with(Props) {

  errorCaptionSttManual = ""
  errorReferenceNumber = ""
  errorShipmentId = "";
  isErrorRefNumber = false

  mounted() {
    this.validateRefNumber(this.modelValue.referenceExternal);
    this.validateSttManual(this.modelValue.sttManual, this.modelValue);
    this.validateShipmentId(this.modelValue.sttShipmentId)

    this.errorReferenceNumber = this.errorRepair.externalNumberCaption;
    this.isErrorRefNumber = this.errorRepair.externalNumber;
  }

  get isSelectClient() {
    if (this.formType !== "manual") {
      return this.modelValue.clientName == ""
    } else {
      return false
    }
  }

  get isDisabledSttManual() {
    return isDisableSttManual(this.formType) && this.isSelectClient;
  }

  get isClientAccount() {
    return AccountController.accountData.isAllClient;
  }

  get isClientBooking() {
    return BulkBookingController.detailRepairBulkBookingData.bookedType === "client";
  }

  get countryCode() {
    return AccountController.accountData.account_type_detail.countryCode.toLowerCase()
  }

  validateSttManual = debounce(async (value: string, modelValue: any) => {
    if (value === "") {
      this.errorCaptionSttManual = "";
      this.error.sttManual = false;
      return;
    } else if (value.length < 3) {  
      this.errorCaptionSttManual = "bulkBooking.manualSttMinimum";
      this.error.sttManual = true;
    } else {
    const result = await BookingController.validateSttManual({
      clientId: this.getValidateSttManual(modelValue),
      sttManual: value,
      bookingType:
        BulkBookingController.detailRepairBulkBookingData.bookedType === "pos" &&
        this.getAccount.accountType === "partner"
          ? "pos"
          : "client",
      productType: modelValue.productName
    });
    this.error.sttManual = !result.isAllowBooking;
    this.errorCaptionSttManual = this.countryCode == "my" ? result.errorMessageEn || result.errorMessage : result.errorMessage;
    }
  }, 250);



  validateRefNumber(value: string) {
    if (value === "") {
      this.errorReferenceNumber = "";
      this.isErrorRefNumber = false;
      this.error.errorRefExternal = false;
    } else if (value.length < 3) {
      this.errorReferenceNumber = this.$t('bookingShipment.error.minimumRef');
      this.isErrorRefNumber = true;
      this.error.errorRefExternal = true;
    } else {
      this.errorReferenceNumber = "";
      this.isErrorRefNumber = false;
      this.error.errorRefExternal = false
    }
  }

  validateShipmentId = debounce(async(value: string) => {
    try {
      if (!value) {
        this.errorShipmentId = "";
        this.error.sttShipmentId = false;
        return;
      }
      const result = await ShipmentBookingController.validateShipmentIdWithResponse(
        new RequestValidateShipmentId({
          clientCode: this.modelValue.clientName.clientCode || "",
          shipmentId: value
        })
      );
      this.errorShipmentId = "";
      this.error.sttShipmentId = false;
      // prevent infinite looping
      if (
        this.flagEnableHandleSelectClientIdFromShipment &&
        result &&
        this.modelValue.sttShipmentId === value
      ) {
        this.$emit("handleGetClientData", result);
      }
    } catch (err) {
      const { id, en } = err.response.data.message;
      this.errorShipmentId = this.getAccount.accountIsForeign ? en : id;
      this.error.sttShipmentId = true;
    }
  }, 250)

  getValidateSttManual(modelValue: any) {
    if (
      BulkBookingController.detailRepairBulkBookingData.bookedType === "client"
    ) {
      return modelValue.clientName.id;
    } else if (this.getAccount.accountType === "client") {
      return this.getAccount.accountClientId;
    } else {
      return "";
    }
  }

  get getAccount(): any {
    return {
      accountType: AccountController.accountData.account_type,
      cityCode: AccountController.accountData.account_type_detail
        .partnerLocation
        ? AccountController.accountData.account_type_detail.partnerLocation
            .city_code
        : "",
      accountClientId: AccountController.accountData.account_type_detail.id
        ? AccountController.accountData.account_type_detail.id
        : "",
      isCodBooking:
        AccountController.accountData.account_type_detail.partnerIsCodBooking,
      accountTypeDetail: AccountController.accountData.account_type_detail,
      accountIsForeign: AccountController.accountData.accountIsForeign
    };
  }

  get getErrorMandatory() {
    return this.isErrorRefNumber || this.errorMandatory;
  }

  setErroMandatory() {
    this.$emit("setFieldIndex", 2);
  }

  get refNumberOpsionalOrAsterik() {
    return !this.isDO;
  }

  get flagEnableHandleSelectClientIdFromShipment() {
    return FlagsPermissionBooking.permission_generate_client_data_from_shipment_id.isEnabled();
  }
}
